module.exports = __webpack_public_path__ + "img/zk-icon-order.66e37cad.svg";